export default __webpack_public_path__ + "static/media/shakeHand.225dd5c4.png";